import type {Result} from 'framework';
import type {CopyDayCommand} from '../../domain/copy-day-command';
import type {DashboardError} from '../../domain/errors';
import type {MealDetail} from '../../domain/meal-detail';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface CopyDayInput {
  readonly command: CopyDayCommand;
}

export class CopyDay {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  execute(input: CopyDayInput): Promise<Result<readonly MealDetail[], DashboardError>> {
    return this.dashboardRepository.copyDay({command: input.command});
  }
}
